import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  DeleteShortLink_Url,
  getMsgShortLinks_Url,
  ShortLinkList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
// import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import DeleteButton from "../buttons/DeleteButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import "./ShortLinkList.css";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
import PaymentShortLinkDialog from "./PaymentShortLinkDialog";

class ShortLinkList extends Component {
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  breadCrumb = [
    { pageid: "/messages", uiname: "Message List" },
    { pageid: "", uiname: "Short Link List" },
  ];
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      initialPage: 0,
      pageSize: 20,
      shortLinkList: [],
      messageWiseClickCount: [],
      msgShortLinkList: [],
      open: false,
      isAscSort: false,
      sortDirection: "asc",
    };
    this.getShortLinkList(this.state.pageNo, this.state.pageSize, this.state.sortColumn, this.state.isAscSort);
    this.debouncedSearch = _.debounce(this.getShortLinkList, 800);
  }

  getShortLinkList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(ShortLinkList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let shortLinkList = output.data.shortLinkList;
          let messageWiseClickCount = output.data.messageWiseClickCount;
          let page = output.data.page;
          let isPaging = false;
          let isMessagePaging = false;
          if (shortLinkList?.length > 10) {
            isPaging = true;
          }
          if (messageWiseClickCount.length > 10) {
            isMessagePaging = true;
          }
          for (let i = 0; i < shortLinkList?.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }

          for (let i = 0; i < messageWiseClickCount.length; i++) {
            messageWiseClickCount[i].messageCreateOn = Utils.getUtcToLocal(
              messageWiseClickCount[i].messageCreateOn
            );
          }
          this.setState({
            isPaging: isPaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            isMessagePaging: isMessagePaging,
            shortLinkList: shortLinkList,
            messageWiseClickCount: messageWiseClickCount,
          });
        } else {
        }
      }
    );
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  deleteShortLink(data) {
    const postObject = {
      header: this.header,
      shortLink: {
        id: data.id,
        eventId: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(DeleteShortLink_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  showActionButton(rowData) {
    return (
      <span className="action-button">
        <DeleteButton
          title={rowData.sourceLink}
          pageId="shortLink"
          domainObject={rowData.sourceLink}
          onClick={this.deleteShortLink.bind(this, rowData)}
        />
      </span>
    );
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessages");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages");
    } else {
      this.props.navigate("/messages");
    }
  }

  getMsgShortLinks(e, data) {
    const postObject = {
      header: this.header,
      messageId: data.messageId,
    };
    FetchServerData.callPostService(getMsgShortLinks_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let msgShortLinkList = output.data.shortLinkList;
          let isMsgShortLinkPaging = false;
          if (msgShortLinkList?.length > this.state.pageSize) {
            isMsgShortLinkPaging = true;
          }
          for (let i = 0; i < msgShortLinkList?.length; i++) {
            msgShortLinkList[i].createdon = Utils.getUtcToLocal(
              msgShortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isMsgShortLinkPaging: isMsgShortLinkPaging,
            msgShortLinkList: msgShortLinkList,
          });
        } else {
        }
      }
    );
  }
  handleClose() {
    this.setState({ open: false });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.getShortLinkList(currentPageIndex, pageSize);
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
  }

  handleOpen = (e, data) => {
    if (
      this.paymentShortLinkDialogueRef &&
      this.paymentShortLinkDialogueRef.current
    ) {
      this.paymentShortLinkDialogueRef.current.showMsgShortLinkList(
        data?.messageId,
        0,
        10,
        data.clickCount
      );
    }
  };

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        this.getShortLinkList(pageNo, pageSize, column, isAscSort);
      }
    );
  }
  render() {
    this.paymentShortLinkDialogueRef = React.createRef();
    return (
      <>
        {this.props.action !== "Insights" && (
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            backCallback={this.viewCancel.bind(this)}
            name="View and manage your short links."
          />
        )}

        <div className="row mt-3 pe-0">
          <div className="col md-12 pe-0">
            <div className="card rounded-0">
              <div
                className="row justify-content-between"
                style={{ padding: "0.6em 1.2rem" }}
              >
                <div className="d-flex col-12 col-lg-5 col-xl-5">
                  <div className="col-12 text-start totalResults align-self-center">
                    <span className="me-4">
                      These are the short links currently used in your messages.
                    </span>
                  </div>
                </div>
                <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                  <span className="me-4 totalResults">
                    Short links: {this.state.totalRecords}
                  </span>
                  <TextField
                    id="standard-search"
                    placeholder="Search"
                    type="text"
                    variant="standard"
                    value={this.state.searchText}
                    onChange={this.onSearchChange.bind(this)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            onClick={this.getShortLinkList.bind(
                              this,
                              0,
                              this.state.pageSize
                            )}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              this.setState({ searchText: "" }, () => {
                                this.getShortLinkList(0, this.state.pageSize);
                              });
                            }}
                            disabled={!this.state.searchText}
                          >
                            <ClearIcon
                              style={{
                                opacity: this.state.searchText ? 1 : 0.4,
                                fontSize: "1.25rem",
                                color: "353538",
                              }}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="table-responsive paginationTable">
                <table className="table text-start table-hover">
                  <thead className="paginationTableThead">
                    <tr>
                      <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("createdon")}>
                        Date Created
                        {this.state.sortColumn === "createdon" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("sourceLink")}>
                        Target Page
                        {this.state.sortColumn === "sourceLink" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("targetLink")}>
                        Short Link
                        {this.state.sortColumn === "targetLink" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      <th className="col fw-bold cursor-pointer" onClick={() => this.handleSort("count")}>
                        # of Clicks
                        {this.state.sortColumn === "count" &&
                          (this.state.sortDirection === "asc" ? (
                            <i
                              class="fa fa-long-arrow-up ps-1"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <i class="fa-solid fa-arrow-down-long ps-1"></i>
                          ))}
                      </th>
                      {/* <th className="col fw-bold">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.shortLinkList?.map((rowData, index) => (
                      <tr
                        key={rowData.id}
                        // onClick={() =>
                        //   window.open(rowData.sourceLink, "_blank")
                        // }
                        style={{
                          backgroundColor:
                            rowData.id === this.state.messageId
                              ? "#e6effc"
                              : "",
                        }}
                      >
                        <td
                          style={{ width: "150px" }}
                          onClick={() =>
                            window.open(rowData.sourceLink, "_blank")
                          }
                        >
                          {rowData.createdon}
                        </td>
                        <td
                          style={{ width: "400px" }}
                          onClick={() =>
                            window.open(rowData.sourceLink, "_blank")
                          }
                        >
                          <a
                            href={rowData.sourceLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="anchortag action-text"
                            onClick={(e) => e.stopPropagation()} // prevent tr click when clicking this link
                            title={rowData.sourceLink}
                          >
                            {Utils.truncateString(rowData.sourceLink, 50)}
                          </a>
                        </td>
                        <td
                          style={{ width: "340px" }}
                          onClick={() =>
                            window.open(rowData.sourceLink, "_blank")
                          }
                        >
                          {Utils.truncateString(rowData.targetLink, 50)}
                        </td>
                        <td
                          style={{ width: "160px" }}
                          onClick={() =>
                            window.open(rowData.sourceLink, "_blank")
                          }
                        >
                          {rowData.count}
                        </td>
                        {/* <td style={{ width: "120px" }}>
                          {this.showActionButton(rowData)}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {this.state.totalRecords === 0 && (
                <div
                  className="row text-center"
                  style={{ padding: "6px 20px" }}
                >
                  <h5 className="dataNotAvailable">No data found.</h5>
                </div>
              )}
              {this.state.totalRecords > this.state.pageSize && (
                <div className="row justify-content-between pagination p-1">
                  <div className="d-flex col-12 col-lg-4 col-xl-4">
                    <div className="pageSize col-12 text-start">
                      Page {this.state.pageNo + 1} of {this.state.totalPages}
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-8 col-xl-8">
                    <div className="col-12 text-end">
                      <Pagination
                        showPerPage={this.state.showPerPage}
                        pageNo={this.state.pageNo}
                        onPaginationChange={this.onPaginationChange.bind(this)}
                        total={this.state.totalRecords}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <PaymentShortLinkDialog
          ref={this.paymentShortLinkDialogueRef}
          style={{ float: "right" }}
        />
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="msgShortLinkDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Payment Short Link</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <>
              <div
                md={12}
                className="mt-4 tableContact materialTable"
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                }}
              >
                {" "}
                <MaterialTable
                  title=""
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Mobile",
                      field: "contactMobile",
                      cellStyle: {
                        width: "12%",
                        textTransform: "none",
                      },
                    },
                    {
                      title: "Date Click",
                      field: "createdon",
                      cellStyle: {
                        width: "12%",
                        textTransform: "none",
                      },
                    },
                    {
                      title: "Payment Link",
                      field: "targetLink",
                      render: (rowData) => {
                        return (
                          <>
                            <a
                              href={rowData.targetLink}
                              target="_blank"
                              className="anchortag fw-bold"
                            >
                              {Utils.truncateString(rowData.targetLink, 80)}
                            </a>
                          </>
                        );
                      },
                      cellStyle: {
                        width: "40%",
                        textTransform: "lowercase",
                      },
                    },
                    {
                      title: "# of Clicks",
                      field: "count",
                      cellStyle: {
                        width: "12%",
                      },
                    },
                  ]}
                  data={this.state.msgShortLinkList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isMsgShortLinkPaging,
                  }}
                  onChangePage={(page, pageSize) => {
                    this.handleMaterialTablePageChange(page, pageSize);
                  }}
                />
              </div>
            </>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default withRouter(ShortLinkList);
